import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "../../constant";
import AparEmployeeHeader, { normalizeManagers } from "../../component/common/AparEmployeeHeader";
import AparFullDetailContent from "./AparFullDetailContent";

const ROLE_LABEL: any = {
  reporting: "Reporting Manager",
  reviewing: "Reviewing Manager",
  accepting: "Accepting Authority",
};

class AparEmployeeFullDetailView extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const locationState = props.location?.state || {};
    const { viewerRole, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, kpiReportId } = locationState;
    this.state = {
      viewerRole,
      kpiReportId,
      employeeData: { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Employee Appraisal Details - " + CONSTANT.organisation.name;
  }

  render() {
    const { employeeData, viewerRole, kpiReportId } = this.state;

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              {/* Header */}
              <div className="row mb-3">
                <div className="col-md-8">
                  <h1 className="page-title">
                    <i className="fa fa-file-text-o text-primary mr-2" />
                    Employee Appraisal Details
                  </h1>
                  {employeeData && (viewerRole in ROLE_LABEL) && (
                    <span className="badge badge-info">{ROLE_LABEL[viewerRole]}</span>
                  )}
                </div>
                <div className="col-md-4 text-right">
                  <button className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                    <i className="fa fa-arrow-left mr-2" />Back
                  </button>
                </div>
              </div>
              <AparEmployeeHeader {...employeeData} />

              <AparFullDetailContent
                viewerRole={viewerRole}
                employeeData={employeeData}
                kpiReportId={kpiReportId}
                onEmployeeDataLoaded={(data: any) => this.setState({ employeeData: data })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(AparEmployeeFullDetailView);
